import type { UpdateWages } from '@web/onboarding/Checklist/onboardingChecklist.types';
import type { RestangularEmployee } from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';
import WagesForEmployeesContent from '@web/onboarding/Checklist/DefineWagesModal/WagesForEmployeesContent';
import useEmployeesWages from '@web/onboarding/Checklist/DefineWagesModal/hooks/useEmployeesWages';

type Props = {
  employees: RestangularEmployee[];
  updateWages: UpdateWages;
  onCancel: () => void;
  afterSubmitCallback?: () => void;
};

const WagesForEmployeesContentWithData = ({
  employees,
  updateWages,
  afterSubmitCallback,
  onCancel,
}: Props) => {
  const { fields, submitWages } = useEmployeesWages({
    employees,
    updateWages,
    afterSubmitCallback,
  });

  return <WagesForEmployeesContent fields={fields} submitWages={submitWages} onCancel={onCancel} />;
};

export default WagesForEmployeesContentWithData;
